import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance, diyInstance } from './instance'

export default class DesensitizationService {
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataDesensitizationRule?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增脱敏规则
  static async createDesensitization(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataDesensitizationRule', payload)
    )
    return Callback(err, res)
  }
  // 编辑脱敏规则
  static async editDesensitization(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/DataDesensitizationRule/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除脱敏规则
  static async deleteDesensitization(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/DataDesensitizationRule/many', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 导出脱敏规则
  static async exportDesensitization(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataDesensitizationRule/export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取脱敏应用列表
  static async getAppList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataDesensitizationApp?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取角色接口
  static async getCharactor() {
    const [err, res] = await To(diyInstance.post('/api/sysrole/getSysRole'))
    return Callback(err, res)
  }
  // 新增脱敏应用
  static async createApplication(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataDesensitizationApp', payload)
    )
    return Callback(err, res)
  }
  // 编辑脱敏应用
  static async editApplication(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/DataDesensitizationApp/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除
  static async deleteApplication(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/DataDesensitizationApp/many', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 脱敏应用导出
  static async exportDataDesensitizationApp(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataDesensitizationApp/export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
}
